module.exports = __webpack_public_path__ + "static/media/alerta_1.61107619.svg";